import { Component, OnInit } from '@angular/core';
import {catchError} from 'rxjs/operators';
import {StudentService} from '../../../shared/services/student.service';
import {Observable, of} from 'rxjs';
import {ModalService} from '../../../shared/services/modal.service';
import {ActivatedRoute} from '@angular/router';
import { ChangeDnaData } from 'src/app/api/models';

@Component({
    selector: 'app-public-student-current-dna',
    templateUrl: './public-student-current-dna.component.html',
    styleUrls: ['./public-student-current-dna.component.scss'],
    standalone: false
})
export class PublicStudentCurrentDnaComponent implements OnInit {

  public isLoading = false;
  public currentDna: {
    dnaData?: ChangeDnaData;
    id: string;
    timestamp: string;
  } = {
    dnaData: undefined,
    id: '',
    timestamp: ''
  };

  constructor(public studentService:StudentService, public modal:ModalService, public activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {

    this.activatedRoute.paramMap.subscribe( (params) => {

      const id = params.get('id');

      if (typeof id === 'string') {
        this.getPublicStudentprofileDnaCurrent(id);
      }

    });

  }

  /**
   * Load current DNA of a student profile
   *
   * @param $id
   */
  getPublicStudentprofileDnaCurrent($id:string) {

    this.isLoading = true;

    this.studentService.apiGetPublicStudentprofileDnaCurrent($id).pipe(catchError(this.handleError('apiGetPublicStudentprofileDnaCurrent', false))).subscribe( (result:any) => {
      this.isLoading = false;
      if (result) {

        if (result.hasOwnProperty('dnaData')) {
          result.dnaData = JSON.parse(result.dnaData);
        }

        this.currentDna = Object.assign(this.currentDna, result);

      }

    });

  }

  /**
   * Error handler
   *
   * @param operation
   * @param result
   */
  handleError<T>(operation:string = '', result?: T) {
    return (error: any): Observable<T> => {

      // Handle given operation
      switch (operation) {

        case 'apiGetPublicStudentprofileDnaCurrent':
          // Do not perform any action, profile could be non-existing
          break;

        default:
          this.modal.Alert('Error', 'Something went wrong, please try again');
          break;

      }

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}
